import React from 'react';
import { IAssignment } from '@/components/interfaces';
import cn from '@/utils/cn';
import Drawer from '@/components/ui/Drawer';
import Icon from '@/components/ui/Icon';
import useGradesTableStore from '@/components/staffer/AssignmentsBasedGradesTable/store/useGradesTableStore';

interface IAssignmentDrawerButtonProps {
  assignment: IAssignment;
}

export function AssignmentDrawerButton({ assignment }: IAssignmentDrawerButtonProps) {
  const setAssignment = useGradesTableStore(state => state.setAssignment);

  return (
    <Drawer.Trigger
      className={cn(
        'tw-bg-transparent tw-outline-none tw-border-none tw-inline-flex tw-items-center tw-justify-center',
        'tw-cursor-pointer',
      )}
      onClick={() => setAssignment(assignment)}
    >
      <Icon icon="ChevronRight" size={16} />
    </Drawer.Trigger>
  );
}
